import { StyleSheet } from 'react-native';

import { COLOR, lightGrey } from 'utils/colors';
import {
    heightPercentageToDP,
    isMobileMediaQuery,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    container: {
        flexGrow: 1,
        maxWidth: 420,
        alignItems: 'center',
        marginHorizontal: 'auto',
        paddingHorizontal: widthPercentageToDP(16),
        ...(isMobileMediaQuery
            ? {
                  paddingVertical: 80,
              }
            : { paddingBottom: 70 }),
        justifyContent: isMobileMediaQuery ? 'flex-start' : 'center',
    },
    containerLandscape: {
        maxWidth: 700,
        paddingVertical: isMobileMediaQuery ? 30 : 70,
    },
    logoContainer: {
        marginBottom: isMobileMediaQuery ? 80 : 65,
    },
    logoContainerLandscape: {
        marginBottom: 24,
    },
    title: {
        marginBottom: heightPercentageToDP(16),
    },
    text: {
        marginBottom: isMobileMediaQuery ? 58 : 40,
    },
    textLandscape: {
        marginBottom: 16,
    },
    btnContainer: {
        marginTop: heightPercentageToDP(12),
        marginBottom: 32,
    },
    btnContainerLandscape: {
        marginBottom: 16,
    },
    btnWithMargin: {
        marginRight: widthPercentageToDP(17),
    },
    btnAppleMarket: {
        width: 121,
    },
    downloadContainer: {
        width: 270,
    },
    separatorContainer: {
        marginBottom: heightPercentageToDP(48),
    },
    separatorContainerLandscape: {
        marginBottom: heightPercentageToDP(8),
    },
    separator: {
        width: '100%',
        height: 1,
        backgroundColor: lightGrey(0.2),
    },
    primaryBtn: {
        width: isMobileMediaQuery ? '100%' : 'auto',
        minWidth: 120,
        paddingHorizontal: 18,
    },
    btnText: {
        color: COLOR.background,
    },
    separatorText: {
        position: 'absolute',
        top: 0,
        right: '50%',
        // @ts-ignore
        transform: [{ translateY: '-50%' }, { translateX: '50%' }],
        paddingHorizontal: 5,
    },
});

export default styles;
